import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

//import css
import styles from './styles.module.scss'

const TextWithLabel = ({
  text,
  labelText,
  align,
  alignRight,
  className,
  labelClassName,
  textClassName
}) => {

  const containerClasses = classNames(
    styles.container,
    { 
      [styles.aligned]: align,
      [styles.alignedRight]: alignRight,
      [className]: className
    }
  )
  
  const labelClasses = classNames(
    styles.label,
    {[labelClassName]: labelClassName}
  )

  const textClasses = classNames(
    styles.text,
    {[textClassName]: textClassName}
  )

  return (
    <div className={containerClasses}>
      <div className={labelClasses}>{labelText}</div>
      <div className={textClasses}>{text}</div>
    </div>
  )
}

TextWithLabel.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  labelText: PropTypes.string,
  align: PropTypes.bool,
  alignRight: PropTypes.bool,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  textClassName: PropTypes.string
}

export default TextWithLabel